import { render, staticRenderFns } from "./shop-wholesale.component.vue?vue&type=template&id=04eeeecc&scoped=true&"
import script from "./shop-wholesale.component.vue?vue&type=script&lang=js&"
export * from "./shop-wholesale.component.vue?vue&type=script&lang=js&"
import style0 from "./shop-wholesale.component.vue?vue&type=style&index=0&id=04eeeecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eeeecc",
  null
  
)

export default component.exports